import { NavigateBackLink } from '@exam-management/components';
import { useParams } from '@exam-management/router';
import { PageHeader } from '@shared/components';

export default function QSetGeneratorResultsHeader() {
  const { courseId } = useParams(`/exam-courses/:courseId/qsets/generator/results`);

  return (
    <PageHeader
      title='QSet Generation Results'
      linkAdornment={
        <NavigateBackLink
          to={{
            pathname: '/exam-courses/:courseId/qsets',
          }}
          params={{ courseId: courseId }}
          label='Back to QSet Generator'
          replace
        />
      }
    ></PageHeader>
  );
}
